import * as React from "react";
import { User } from "../../userTypes";
import Select from "react-select";
import CountryList from "app/data/countryList";

type Props = {
  user: User;
  publicOfficial?: any;
  countryOfResidence?: any;
  nationality?: any;
};

type State = {
  publicOfficial: Boolean;
  countryOfResidence: String;
  nationality: String;
};

export default class ComplianceScreeningData extends React.Component<
  Props,
  State
> {
  handlePublicOfficialEvent = (value: boolean) => {
    this.props.publicOfficial(value);
    this.setState({ publicOfficial: value });
  };

  handleCountryOfResidenceEvent = (value) => {
    this.props.countryOfResidence(value);
    this.setState({ countryOfResidence: value });
  };

  handleNationalityEvent = (value) => {
    this.props.nationality(value);
    this.setState({ nationality: value });
  };

  render() {
    const { user } = this.props;

    return (
      <section className="page">
        <table
          style={{
            fontSize: "14px",
            paddingTop: "10px",
            width: "100%",
          }}
          className="BOTable"
          cellPadding={0}
          cellSpacing={0}
        >
          <thead>
            <tr>
              <td colSpan={6}>
                <h3
                  style={{
                    borderBottom: "1px solid rgb(204, 204, 204)",
                    fontWeight: 400,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <p style={{ flex: 1 }}>
                    PIP/PEP, country of residence and nationality
                  </p>
                </h3>
              </td>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                Publicly Exposed Person, Prominent Influential Person or
                directly related to someone who is:
              </td>
              {user.public_official == null ? (
                <td> There is no PIP/PEP data for this user. </td>
              ) : (
                <td> {String(user.public_official)} </td>
              )}
              <td>
                <Select
                  onChange={(event) =>
                    this.handlePublicOfficialEvent(Boolean(event.value))
                  }
                  value={
                    this.state?.publicOfficial == null
                      ? { label: String(user.public_official) }
                      : { label: String(this.state?.publicOfficial) }
                  }
                  options={[
                    { value: true, label: "true" },
                    { value: false, label: "false" },
                  ]}
                  placeholder={String(user.public_official)}
                />
              </td>
            </tr>

            <tr>
              <td> Country of residence: </td>
              {user.country_of_residence == null ? (
                <td> There is no country of residence data for this user. </td>
              ) : (
                <td> {user.country_of_residence} </td>
              )}
              <td>
                <Select
                  onChange={(event) =>
                    this.handleCountryOfResidenceEvent(event.value)
                  }
                  styles={{
                    menu: (base) => ({ ...base, position: "relative" }),
                  }}
                  options={CountryList}
                  value={
                    this.state?.countryOfResidence == null
                      ? { label: user.country_of_residence }
                      : { label: this.state?.countryOfResidence }
                  }
                  placeholder={user.country_of_residence}
                />
              </td>
            </tr>

            <tr>
              <td> Nationality: </td>
              {user.nationality == null ? (
                <td> There is no Nationality data for this user. </td>
              ) : (
                <td> {user.nationality} </td>
              )}
              <td>
                <Select
                  onChange={(event) => this.handleNationalityEvent(event.value)}
                  styles={{
                    menu: (base) => ({ ...base, position: "relative" }),
                  }}
                  options={CountryList}
                  value={
                    this.state?.nationality == null
                      ? { label: user.nationality }
                      : { label: this.state?.nationality }
                  }
                  placeholder={user.nationality}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    );
  }
}
